import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IVenueMapViewModel } from 'src/app/modules/shared/interfaces/map/venueMapViewModel.interface';
import { Constants } from 'src/app/modules/shared/models/constants';
import { IVenueMapOverlay } from 'src/app/modules/shared/models/map/overlays/venueMapOverlay.interface';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-venue-maps-toggle-button',
    templateUrl: './venue-maps-toggle-button.component.html',
    styleUrl: './venue-maps-toggle-button.component.scss',
    standalone: false
})
export class VenueMapsToggleButtonComponent {
  @Output() onButtonStateChanged = new EventEmitter<boolean>();

  @Input() map: google.maps.Map = null;
  @Input() venueMaps: IVenueMapViewModel[] = [];
  @Input() groundOverlays: IVenueMapOverlay[] = [];
  @Input() tileOverlays: IVenueMapOverlay[] = [];

  @Input() toggleState = true;

  public isMobile = false;
  public readonly T = T;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < Constants.xs;
  }

  get btnTitle(): string {
    return this.toggleState
      ? this.translateService.instant(T.settings.location_manager.hide_venue_maps)
      : this.translateService.instant(T.settings.location_manager.show_venue_maps);
  }

  onClick($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.toggleState = !this.toggleState;

    (this.groundOverlays as unknown as google.maps.GroundOverlay[]).forEach(overlay => {
      overlay.setMap(this.toggleState ? this.map : null);
    });

    this.toggleTileOverlays();
    this.onButtonStateChanged.emit(this.toggleState);
  }

  private toggleTileOverlays() {
    if (this.toggleState) {
      this.showTileOverlays();
    } else {
      this.hideTileOverlays();
    }
  }

  private hideTileOverlays() {
    (this.tileOverlays as unknown as google.maps.ImageMapType[]).forEach(overlay => {
      const index = this.map.overlayMapTypes.getArray().indexOf(overlay);
      if (index > -1) {
        this.map.overlayMapTypes.removeAt(index);
      }
    });
  }

  private showTileOverlays() {
    (this.tileOverlays as unknown as google.maps.ImageMapType[]).forEach(overlay => {
      if (this.map.overlayMapTypes.getArray().indexOf(overlay) === -1) {
        this.map.overlayMapTypes.insertAt(0, overlay);
      }
    });
  }

}
